module.exports = __webpack_public_path__ + "media/add-ons/all_hands@1x-363a7c83.png";